var taroApp = taroApp || {};

taroApp = {
	init: function () {
		"use strict";

		this.setMovie(document, jQuery);
		this.topGallery(jQuery);
		this.nextMore(jQuery);
		this.tabMenu(jQuery);
		this.pageScroll(jQuery);
		this.pageTopScroll(jQuery);
		this.developLang(jQuery);
		this.achievementDisplay(jQuery);
		this.telLink();
		this.jQueryMobileMenuHelper(jQuery);
	},
	is_mobile: function () {
		var is_mobile = false;
		if (navigator.userAgent.indexOf('iPhone') > 0 ||
			navigator.userAgent.indexOf('iPad') > 0 ||
			navigator.userAgent.indexOf('iPod') > 0 ||
			navigator.userAgent.indexOf('Android') > 0) {
			is_mobile = true;
		}
		return is_mobile;
	},
	setMovie: function (d, $) {
		"use strict";
		var movie = document.getElementById('movie');

		if (this.is_mobile()) {

			if (movie) {
				movie.parentNode.removeChild(movie);

				var ele = d.createElement("img");
				ele.src = "/wp-content/themes/tarosky2014/assets/images/top/main-img.jpg";
				ele.className = 'main-img__visual';
				ele.alt = 'いいものを作りたい';

				d.getElementById("js-main-img").appendChild(ele);
			}
		} else {

			var $movie = $('#movie');
			$movie.fadeTo(0);
			if (movie) {
				movie.addEventListener('canplay', function () {
					setTimeout(function () {
						movie.play();
					}, 100);
					$movie.delay(100).animate({'opacity': 1}, 1200);
				});
				movie.load();
			} else {
				$('.main-img__visual').delay(100).animate({'opacity': 1}, 1200);
			}
		}

	},
	topGallery: function ($) {
		"use strict";

		window.onload = function () {
			var $main = $('#js-office-into--gallery__main');
			var $img = $main.children('.office-into--gallery__img');
			var $title = $main.children('.office-into--gallery__title');
			var $text = $main.children('.office-into--gallery__text');
			var $thumb = $('#js-office-into--gallery__list').find('a');
			var className = 'is--office-into--gallery-active';

			$thumb.first().addClass(className);
			$thumb.on('click', function () {
				if ($(this).hasClass(className) === false) {
					$thumb.removeClass(className);
					$(this).addClass(className);
					$img.stop().hide().attr('src', $(this).attr('href')).fadeIn();
					$title.text($(this).children('img').attr('alt'));
					$text.text($(this).children('img').attr('data-text'));
				}
				return false;
			});
		};

	},
	nextMore: function ($) {
		"use strict";

		var more = $('.js-next-more');
		more.on('click', function () {
			$(this).hide().next().fadeIn();
			return false;
		});

	},
	tabMenu: function ($) {
		"use strict";

		/**
		 * タブメニュー
		 * @param tabMenu_ele
		 * @param tabContent_ele
		 */
		function tabMenu(tabMenu_ele, tabContent_ele) {
			var $tabMenu = $(tabMenu_ele).children('li');
			var $tabContent = $(tabContent_ele).children('dl');
			var activeClass = 'recruit-details__menu--active';

			$tabMenu.first().addClass(activeClass);
			$tabContent.not(':first').hide();

			$tabMenu.on('click', function () {

				if ($(this).hasClass(activeClass)) {
					return;
				}

				$tabMenu.removeClass(activeClass);
				$(this).addClass(activeClass);

				var index = $(this).index();
				$tabContent.hide().eq(index).fadeIn();

				return false;
			});
		}

		tabMenu('#js-recruit-details__menu', '#js-recruit-details__tab-content');

	},
	pageScroll: function ($) {
		"use strict";

		var $link = $('a[href^="#"]');
		var SPEED = 400;

		$link.on('click.pageScroll', function () {
			var FIXED_NAV = 82;
			var href = $(this).attr("href");
			var target = $(href === "#" || href === "" ? 'html' : href);
			var position = target.offset().top;
			position -= FIXED_NAV; // 固定メニュー分、移動位置を下げる処理

			$('body,html').animate({
				scrollTop: position
			}, SPEED, 'swing');
			return false;
		});

	},
	pageTopScroll: function ($) {
		"use strict";

		var topBtn = $('#js-page-to-top');
		topBtn.hide();

		$(window).on('scroll', function () {
			if ($(this).scrollTop() > 150) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
	},
	developLang: function ($) {
		"use strict";

		var SLIDE_SPEED = 250;
		var BREAKPOINT = 640;
		var timer;
		var $title = $('.js-develop-lang__list-title');
		var $next = $title.next();
		var openClass = 'develop-lang__list-title--open';

		var Accordion = function () {
			if ($(window).width() <= BREAKPOINT) {
				this.init();
			} else {
				this.noMove();
			}
		};

		Accordion.prototype.init = function () {
			$next.hide();
			// resize時必ず一度offにする
			$title.off('click.accordion').removeClass(openClass)
				.on('click.accordion', function () {
					$(this).toggleClass(openClass)
						.next().stop().slideToggle(SLIDE_SPEED, 'swing');
					return false;
				});
		};

		Accordion.prototype.noMove = function () {
			$next.show();
			$title.off('click.accordion');
		};

		var accordion = new Accordion();

		$(window).on('load resize', function () {
			clearTimeout(timer);
			timer = setTimeout(function () {
				accordion = new Accordion();
			}, 300);
		});

	},
	achievementDisplay: function ($) {
		"use strict";

		var $menus = $('#js-switch-menu');
		var $contents = $('#js-switch-content');
		var $content = $contents.children();
		var $menu = $menus.find('input');
		var $menuLen = $menu.length;
		var className = '.js-achievement--';
		var showClass = 'js-achievement--show';

		// 初期化、最新6件を表示
		$content.hide().slice(0, 6).show().addClass(showClass);

		function showCheck() {
			$content.fadeOut().removeClass(showClass);
			for (var i = 0; i < $menuLen; i++) {
				if ($menu.eq(i).prop("checked")) {
					$(className + $menu.eq(i).val()).stop().addClass(showClass).fadeIn();
				}
			}
		}

		function contentClear() {
			$('.' + showClass).each(function (index) {
				if (index % 3 === 0) {
					$(this).css('clear', 'both');
				} else {
					$(this).css('clear', 'none');
				}
			});
		}

		$menu.on('change', function () {
			showCheck();
			contentClear();
		});
		contentClear();

	},

	/**
	 * モバイルの場合は電話番号にリンクを設定する。
	 */
	telLink: function () {
		var tel = document.getElementById('company__tel');

		if (this.is_mobile() && tel) {
			tel.innerHTML = '<a href="tel:0358392760">03-5839-2760</a>';
		}
	},

	/**
	 * ウィンドウをリサイズした時にトップメニューのアコーディオンが自動で閉じるようにする
	 */
	jQueryMobileMenuHelper: function ($) {
		// close on resize
		$(window).on('load resize', function () {
			if ($("html").hasClass("build-menu-open")) {
				$("#js-sp-menu__open").click();
			}
		});
	}
};

jQuery(document).ready(function () {
	taroApp.init();
});
